<template>
  <form class="mx-0 flex flex-wrap" @submit.prevent="createChannel()">
    <div class="w-full">
      <label :class="{ error: $v.inboxName.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.INBOX_NAME.LABEL') }}
        <input
          v-model.trim="inboxName"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.JIO_SMS.INBOX_NAME.PLACEHOLDER')"
          @blur="$v.inboxName.$touch"
        >
        <span v-if="$v.inboxName.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.INBOX_NAME.ERROR') }}
        </span>
      </label>
    </div>
    
    <div class="w-full">
      <label :class="{ error: $v.dlt_entity_id.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.DLT_ENTITY_ID.LABEL') }}
        <input
          v-model.trim="dlt_entity_id"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.JIO_SMS.DLT_ENTITY_ID.PLACEHOLDER')"
          @blur="$v.dlt_entity_id.$touch"
        >
        <span v-if="$v.dlt_entity_id.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.DLT_ENTITY_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full">
      <label :class="{ error: $v.username.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.USERNAME.LABEL') }}
        <input
          v-model.trim="username"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.JIO_SMS.USERNAME.PLACEHOLDER')"
          @blur="$v.username.$touch"
        >
        <span v-if="$v.username.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.USERNAME.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full">
      <label :class="{ error: $v.password.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.PASSWORD.LABEL') }}
        <input
          v-model.trim="password"
          type="password"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.JIO_SMS.PASSWORD.PLACEHOLDER')"
          @blur="$v.password.$touch"
        >
        <span v-if="$v.password.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.PASSWORD.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full">
      <label :class="{ error: $v.sender_id.$error }">
        {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.SENDER_ID.LABEL') }}
        <input
          v-model.trim="sender_id"
          type="text"
          :placeholder="$t('INBOX_MGMT.ADD.SMS.JIO_SMS.SENDER_ID.PLACEHOLDER')"
          @blur="$v.sender_id.$touch"
        >
        <span v-if="$v.sender_id.$error" class="message">
          {{ $t('INBOX_MGMT.ADD.SMS.JIO_SMS.SENDER_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-full">
      <woot-submit-button
        :loading="uiFlags.isCreating"
        :button-text="$t('INBOX_MGMT.ADD.SMS.JIO_SMS.SUBMIT_BUTTON')"
      />
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  data() {
    return {
      dlt_entity_id: '',
      username: '',
      password: '',
      sender_id: '',
      inboxName: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      globalConfig: 'globalConfig/get',
    }),
  },
  validations: {
    dlt_entity_id: { required },
    username: { required },
    password: { required },
    sender_id: { required },
    inboxName: { required },
  },
  methods: {
    ...mapActions('inboxes', ['createChannel']),
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const jioSmsChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName,
          channel: {
            type: 'jio_sms',
            dlt_entity_id: this.dlt_entity_id,
            username: this.username,
            password: this.password,
            sender_id: this.sender_id,
          },
        });

        // Redirect to agent assignment page following Twilio flow
        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: jioSmsChannel.id,
          },
        });
      } catch (error) {
        // Show error message if channel creation fails
        this.showAlert(this.$t('INBOX_MGMT.ADD.SMS.JIO_SMS.API.ERROR_MESSAGE'));
      }
    },
  },
};
</script>
